module.exports = __webpack_public_path__ + "img/22_newYouth_wm.c55a8fb7.png";